<h2 mat-dialog-title>Training Video</h2>

<mat-dialog-content>
    <p>
        Welcome! Please take a moment to watch this quick training video to help you get started with the Specsfin system.
    </p>

    <div class="video-container">
        @if (videoUrl) {
            <iframe
                [src]="videoUrl"
                title="Specsfin Training Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        }
    </div>

    <mat-checkbox class="dont-show-checkbox" [(ngModel)]="dontShowAgain">
        Don't show this again
    </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" (click)="onClose()">Close</button>
</mat-dialog-actions>
